import styled from "styled-components";

export const FAQ = styled.section`
display: flex;
align-items: center;
justify-content: center;
flex-direction: column;
padding: 100px 0px;
`;

export const FAQTitle = styled.h2`
font-weight: 700;
font-size: 56px;
line-height: 68px;
letter-spacing: 0.01em;
text-transform: uppercase;
color: var(--yellowDark);
margin-bottom: 50px;    
`;

export const FAQTxt = styled.p`
font-weight: 700;
font-size: 38px;
line-height: 68px;
letter-spacing: 0.01em;
text-transform: uppercase;
color: var(--white);
padding-bottom: 95px;
`;

export const FAQContent = styled.div`
padding-top: 95px;
`;